// src/App.tsx

import React, {
  useEffect,
  useState,
} from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";


// =====================================================
// PAGES
// =====================================================

import Home from "./pages/Home";
import Lobby from "./pages/Lobby";
import GameBoard from "./pages/GameBoard";

import Login from "./pages/Login";
import Register from "./pages/Register";

import Profile from "./pages/Profile";


// =====================================================
// GAME GUIDES
// =====================================================

import FasoorGuide from "./pages/guide/FasoorGuide";
import GuideComingSoon from "./pages/guide/GuideComingSoon";
import AllGames from "./pages/games/AllGames";


// =====================================================
// LEGAL PAGES
// =====================================================

import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsConditions from "./pages/legal/TermsConditions";
import CookiePolicy from "./pages/legal/CookiePolicy";

// =====================================================
// SUPPORT PAGES
// =====================================================

import HelpCenter from "./pages/support/HelpCenter";
import ContactUs from "./pages/support/ContactUs";
import ReportProblem from "./pages/support/ReportProblem";
import SupportTicket from "./pages/support/SupportTicket";

// =====================================================
// ADMIN PAGES
// =====================================================

import AdminSupport from "./pages/admin/AdminSupport";
import AdminTicket from "./pages/admin/AdminTicket";
import AdminAnalytics from "./pages/admin/AdminAnalytics";

// =====================================================
// PLATFORM PAGES
// =====================================================

import GameHouse from "./pages/platform/GameHouse";
import AboutPArena from "./pages/platform/AboutPArena";
import HowItWorks from "./pages/platform/HowItWorks";

// =====================================================
// COMPONENTS
// =====================================================

import SplashScreen from "./components/SplashScreen";
import AnalyticsTracker from "./components/AnalyticsTracker";


// =====================================================
// APP
// =====================================================

const App: React.FC = () => {

  // ===================================================
  // PLATFORM STARTUP
  // ===================================================

  const [
    showSplash,
    setShowSplash,
  ] = useState<boolean>(true);


  useEffect(() => {

    /*
      Display the P-ARENA brand when the
      application initially starts.
    */

    const timer =
      window.setTimeout(() => {

        setShowSplash(false);

      }, 5000);


    return () => {

      window.clearTimeout(
        timer
      );

    };

  }, []);


  // ===================================================
  // UI
  // ===================================================

  return (
    <Router>

      {/* ============================================= */}
      {/* VISITOR ANALYTICS                             */}
      {/* ============================================= */}

      <AnalyticsTracker />


      {/* ============================================= */}
      {/* P-ARENA STARTUP SCREEN                        */}
      {/* ============================================= */}

      <SplashScreen
        visible={showSplash}
      />


      {/* ============================================= */}
      {/* APPLICATION ROUTES                            */}
      {/* ============================================= */}

      <Routes>

        {/* =========================================== */}
        {/* HOME                                        */}
        {/* =========================================== */}

        <Route
          path="/"
          element={<Home />}
        />


        {/* =========================================== */}
        {/* GAME FLOW                                   */}
        {/* =========================================== */}

        <Route
          path="/lobby"
          element={<Lobby />}
        />

        <Route
          path="/game"
          element={<GameBoard />}
        />


        {/* =========================================== */}
        {/* GAME GUIDES                                 */}
        {/* =========================================== */}

        <Route
          path="/guides/fasoor"
          element={<FasoorGuide />}
        />

        <Route
          path="/guides/:gameName"
          element={<GuideComingSoon />}
        />


        {/* =========================================== */}
        {/* AUTHENTICATION                              */}
        {/* =========================================== */}

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/register"
          element={<Register />}
        />


        {/* =========================================== */}
        {/* PROFILE                                     */}
        {/* =========================================== */}

        <Route
          path="/profile"
          element={<Profile />}
        />


        {/* =========================================== */}
        {/* LEGAL                                       */}
        {/* =========================================== */}

        <Route
          path="/privacy"
          element={<PrivacyPolicy />}
        />

        <Route
          path="/terms"
          element={<TermsConditions />}
        />

        <Route
          path="/cookies"
          element={<CookiePolicy />}
        />

        {/* =========================================== */}
        {/* SUPPORT                                     */}
        {/* =========================================== */}

        <Route
          path="/help"
          element={<HelpCenter />}
        />

        <Route
          path="/contact"
          element={<ContactUs />}
        />

        <Route
          path="/report"
          element={<ReportProblem />}
        />

        <Route
          path="/support/tickets/:ticketId"
          element={<SupportTicket />}
        />

        {/* =========================================== */}
        {/* ADMIN                                       */}
        {/* =========================================== */}

        <Route
          path="/admin/analytics"
          element={<AdminAnalytics />}
        />

        <Route
          path="/admin/support"
          element={<AdminSupport />}
        />

        <Route
          path="/admin/support/tickets/:ticketId"
          element={<AdminTicket />}
        />

        {/* =========================================== */}
        {/* PLATFORM                                    */}
        {/* =========================================== */}

        <Route
          path="/game-house"
          element={<GameHouse />}
        />

        <Route
          path="/about"
          element={<AboutPArena />}
        />

        <Route
          path="/how-it-works"
          element={<HowItWorks />}
        />

        <Route
          path="/games"
          element={<AllGames />}
        />

      </Routes>

    </Router>
  );
};


export default App;